import {useRef} from 'react';
import type {DesignStudioIntroVideo} from '../../config/blissDesignStudioSlideshow';

/** Three complete automatic plays, then the native Play control owns replays. */
export default function QuickStartVideo({video}:{video:DesignStudioIntroVideo}){
 const completed=useRef(0);
 return <video className="bqs-video" aria-label="See how the free room photo tool works"
  controls autoPlay muted playsInline preload="auto" poster={video.posterUrl} src={video.url}
  onEnded={event=>{
   completed.current++;
   if(completed.current>=3)return;
   const player=event.currentTarget;
   player.currentTime=0;
   // A browser may reject autoplay; native controls remain available to start it.
   void player.play().catch(()=>{});
  }}/>
}
